export default __webpack_public_path__ + "static/media/book2.bfc4ff89.jpg";